// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"249":"7535cdea","290":"5500a912","630":"2a977bd3"}[chunkId] + ".chunk.js";
};